var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1080 1080" },
    },
    [
      _c("g", { attrs: { id: "kreis" } }, [
        _c("path", {
          attrs: {
            d: "m538.83,31.67c68.61,0,135.16,13.43,197.79,39.93,60.51,25.59,114.86,62.24,161.53,108.91,46.68,46.68,83.32,101.02,108.91,161.53,26.49,62.64,39.93,129.18,39.93,197.79s-13.43,135.16-39.93,197.79c-25.59,60.51-62.24,114.86-108.91,161.53-46.68,46.68-101.02,83.32-161.53,108.91-62.64,26.49-129.18,39.93-197.79,39.93s-135.16-13.43-197.79-39.93c-60.51-25.59-114.86-62.24-161.53-108.91-46.68-46.68-83.32-101.02-108.91-161.53-26.49-62.64-39.93-129.18-39.93-197.79s13.43-135.16,39.93-197.79c25.59-60.51,62.24-114.86,108.91-161.53,46.68-46.68,101.02-83.32,161.53-108.91,62.64-26.49,129.18-39.93,197.79-39.93m0-22C246.03,9.67,8.67,247.03,8.67,539.83s237.36,530.17,530.17,530.17,530.17-237.36,530.17-530.17S831.64,9.67,538.83,9.67h0Z",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "Linie_28pt" } }, [
        _c("path", {
          attrs: {
            d: "m831.47,693.5H248.52c-6.08,0-11-4.92-11-11v-99.26c0-6.08,4.92-11,11-11,18.22,0,33.04-14.82,33.04-33.04s-14.82-33.04-33.04-33.04c-6.08,0-11-4.92-11-11v-97.66c0-6.08,4.92-11,11-11h582.95c6.08,0,11,4.92,11,11v97.66c0,6.08-4.92,11-11,11-18.22,0-33.04,14.82-33.04,33.04s14.82,33.04,33.04,33.04c6.08,0,11,4.92,11,11v99.26c0,6.08-4.92,11-11,11Zm-571.95-22h560.95v-78.37c-25.1-5.11-44.04-27.35-44.04-53.94s18.94-48.83,44.04-53.94v-76.76H259.52v76.76c25.1,5.11,44.04,27.35,44.04,53.94s-18.94,48.83-44.04,53.94v78.37Z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m737.03,488.59c-9.67-12.78-28.49-18.65-44.37-18.65-37.64,0-66.3,24.69-66.3,63.88s27.11,64.57,65.26,64.57c20.72,0,36.6-7.94,47.31-21.41l-17.44-12.26c-6.22,8.46-16.57,14.16-29.7,14.16-25.21,0-41.44-18.47-41.44-45.06,0-25.21,17.09-44.72,42.3-44.72,9.84,0,21.41,3.8,27.8,12.6l16.57-13.12Zm-185.08,106.7h21.75v-103.24h37.46v-18.99h-96.68v18.99h37.46v103.24Zm-197.42,0h20.72v-98.24h.35l36.6,98.24h15.19l37.12-98.24h.35v98.24h21.58v-122.23h-34.18l-31.42,86.84h-.52l-31.77-86.84h-34.01v122.23Z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }